import { CommunicationsApiSdk } from '../../api/CommunicationsApiSdk';
import { observable, action } from 'mobx';
import { Product } from '../domain/entities/Product';
import { NotifyMeForm } from '../domain/entities/NotifyMeForm';

export interface IProductNotifyMeRepository {
    communicationApiSdk: CommunicationsApiSdk;
    notifyMeForm: NotifyMeForm;
}

export class ProductNotifyMeRepository {
    private communicationsApiSdk: CommunicationsApiSdk;
    @observable private product: Product;
    @observable private notifyMeForm: NotifyMeForm;

    constructor(config: IProductNotifyMeRepository) {
        this.communicationsApiSdk = config.communicationApiSdk;
        this.notifyMeForm = config.notifyMeForm;
    }

    public subscribeToBackInStockNotification = async ({
        skuId,
        email,
        subscriptionType
    }: {
        skuId: string;
        email: string;
        subscriptionType: string;
    }) => {
        return this.communicationsApiSdk.subscribeToBackInStockNotification(
            skuId,
            email,
            subscriptionType
        );
    };

    public getProduct = () => {
        return this.product;
    };
    public getNotifyMeForm = () => {
        return this.notifyMeForm;
    };
    @action
    public setProduct = (product: Product) => {
        this.product = product;
    };
}
